import React from 'react';
import MusicListView from './MusicListView';
import MusicEditPopupSequence from './MusicEditPopupSequence';
import MusicPermissionToUsePopupSequence from './MusicPermissionToUsePopupSequence';
import Paginator from '../../../common/components/Paginator';
import MusicUploadListView from './MusicUploadListView';
import CustomButton from '../../../common/components/CustomButton';
import { MusicClientContext } from '../../context/MusicClientContext';
import { MusicEntity } from '../../types/MusicEntityTypes';

// アーティスト登録時のアップロードフォームおよび曲の管理のアップロードフォームのRoot Component
export default function MusicManagementView({
  pageCount,
  initialDefaultPermissionToUse,
} : {
  pageCount: number,
  initialDefaultPermissionToUse: number,
}) {
  const [page, setPage] = React.useState(1);
  const [initialized, setInitialized] = React.useState(false);
  const [musics, setMusics] = React.useState<MusicEntity[]>([]);
  const [
    defaultPermissionToUse,
    setDefaultPermissionToUse,
  ] = React.useState(initialDefaultPermissionToUse);
  const [popup, setPopup] = React.useState<null|'editMusic'|'editPermissionToUse'>(null);
  const [selectedMusic, setSelectedMusic] = React.useState<MusicEntity|null>(null);

  const { getMusics } = React.useContext(MusicClientContext);

  const fetchMusics = (newPage: number) => {
    getMusics(newPage).then((data) => {
      setMusics(data.musics);
      setDefaultPermissionToUse(data.artist.allow_use);
      setInitialized(true);
    });
  };

  React.useEffect(() => {
    if (!initialized) {
      fetchMusics(page);
    }
  });

  return (
    <div>
      <p className="is_text_info text_warning">
        <span className="material-symbols-rounded icon_warning">warning</span>
        <b>以下アップロード禁止です。</b>
        <br />
        ・JASRACまたはNexToneに著作権を委託している曲
        <br />
        ・他者が著作権を持ってる曲
        <br />
        ・工程の半分以上がAIによって生成された曲
        <br />
        詳細はこちらの
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href="https://help.frekul.com/136/" target="_blank">ヘルプ</a>
        を必ず読んでからご利用ください。
      </p>
      <MusicUploadListView
        defaultPermissionToUse={defaultPermissionToUse}
        onChange={() => { fetchMusics(page); }}
      />
      <ul>
        <li className="bt">
          <CustomButton type="default" onClick={() => { document.location.href = '/music_distribution/'; }}>音楽配信サービス概要</CustomButton>
        </li>
      </ul>
      <ul>
        <li className="bt">
          <CustomButton type="default" onClick={() => { document.location.href = '/music_albums/'; }}>音楽配信の管理へ</CustomButton>
        </li>
      </ul>
      <h2>アップロード済みの曲</h2>
      <MusicListView
        musics={musics}
        onEdit={(music) => { setSelectedMusic(music); setPopup('editMusic'); }}
        onEditPermissionToUse={(music) => { setSelectedMusic(music); setPopup('editPermissionToUse'); }}
      />
      {popup === 'editMusic' && selectedMusic !== null && (
        <MusicEditPopupSequence
          music={selectedMusic}
          onClose={() => { setPopup(null); setSelectedMusic(null); }}
          onEdit={() => { fetchMusics(page); setPopup(null); setSelectedMusic(null); }}
          onDelete={() => { fetchMusics(page); setPopup(null); setSelectedMusic(null); }}
        />
      )}
      {popup === 'editPermissionToUse' && selectedMusic !== null && (
        <MusicPermissionToUsePopupSequence
          music={selectedMusic}
          initialDefaultPermissionToUse={defaultPermissionToUse}
          onClose={() => { setPopup(null); setSelectedMusic(null); }}
          onEdit={() => { fetchMusics(page); setPopup(null); setSelectedMusic(null); }}
          onBulkEdit={(newDefaultPermissionToUse) => {
            setDefaultPermissionToUse(newDefaultPermissionToUse);
            fetchMusics(page); setPopup(null); setSelectedMusic(null);
          }}
        />
      )}
      <Paginator
        page={page}
        pageCount={pageCount}
        onChange={(newPage) => { setPage(newPage); setInitialized(false); fetchMusics(newPage); }}
      />
    </div>
  );
}
